import React, { memo, useState } from 'react';
import AgentLogo from '@/pages/home/assets/img/agent-logo.png';
import AgentLogoHover from '@/pages/home/assets/img/agent-logo-hover.png';
import { NavMenu } from 'tea-component';
import AgentTipBubble from './AgentTipBubble';
import './index.scss';

const Aigc = () => {
  const [isHover, setIsHover] = useState<boolean>(false);

  return (
    <NavMenu.Item>
      <AgentTipBubble>
        <div
          className="lay-nav-right dbh-agent-logo-wrapper"
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <div className="dbh-agent-logo-wrapper-shine" />
          <img
            className="dbh-agent-logo"
            src={isHover ? AgentLogoHover : AgentLogo}
            alt="Agent Logo"
          />
        </div>
      </AgentTipBubble>
    </NavMenu.Item>
  );
};

export default memo(Aigc);
